import React, { useEffect, useState } from 'react';
import { CookieConsentScript } from '~/shared/scripts/CookieConsent';
import { RaptorScript } from '~/shared/scripts/Raptor';
import isbot from 'isbot';
import { useConfig } from '~/shared/hooks';
import { YotpoScript } from '~/shared/scripts/Yotpo';
import SpiffScript from '~/shared/scripts/SpiffScript';

export const Scripts = () => {
    const [loadComplete, setLoadComplete] = useState(false);
    const [loadTracking] = useState(!isbot(navigator.userAgent));
    const { config } = useConfig();

    const shouldLoadRaptor = loadTracking && !config.isProduction; // gtm loads raptor in production, only for testing

    useEffect(() => {
        const onPageLoad = () => {
            setTimeout(() => {
                setLoadComplete(true);
            });
        };

        if (document.readyState === 'complete') {
            onPageLoad();
        } else {
            window.addEventListener('load', onPageLoad);
            return () => window.removeEventListener('load', onPageLoad);
        }
    }, []);

    return (
        <>
            {loadTracking && <CookieConsentScript />}
            {shouldLoadRaptor && <RaptorScript />}
            {loadComplete && <YotpoScript />}
            {loadComplete && <SpiffScript />}
        </>
    );
};

export default Scripts;
